// Icon Imports
import QUO from "../assets/ic-QUO.svg";
import MSA from "../assets/ic-MSA.svg";
import SOW from "../assets/ic-SOW.svg";
import SLA from "../assets/ic-SLA.svg";
import NDA from "../assets/ic-NDA.svg";
import CSA from "../assets/ic-CSA.svg";
import SAQ from "../assets/ic-SAQ.svg";
import DPA from "../assets/ic-DPA.svg";

const OPEN_OPPORTUNITIES_LANE = "OPEN_OPPORTUNITIES_LANE";
const OPEN_DOC_LANE = "OPEN_DOC_LANE";
const PENDING_APPROVAL_LANE = "PENDING_APPROVAL_LANE";
const APPROVED_LANE = "APPROVED_LANE";
const REJECTED_LANE = "REJECTED_LANE";
const SENT_TO_CLIENT_LANE = "SENT_TO_CLIENT_LANE";
const DOCUMENT_CLIENT_APPROVED_LANE = "DOCUMENT_CLIENT_APPROVED_LANE";
const DOCUMENT_CLIENT_REJECTED_LANE = "DOCUMENT_CLIENT_REJECTED_LANE";
const DOCUMENT_SIGNED_LANE = "DOCUMENT_SIGNED_LANE";
const DRAFT_STATUS = "DRAFT";

// New Kanban SwimLanes
const DRAFT = "DRAFT";
const INTERNAL_REVIEW = "INTERNAL_REVIEW";
const CUSTOMER_REVIEW = "CUSTOMER_REVIEW";
const SIGNED = "SIGNED";

const DEFAULT_SELECTED_LUKE_ANALYTICS = "Luke Analytics";
const DEFAULT_SELECTED_SAMPLE_OPPORTUNITY = "Sample Opportunity";

const NEW_PIPELINE_SWIMLANES = [
  {
    context: DRAFT,
    status: ["DRAFT"],
    heading: "Draft",
    subHeading: "Documents that are editable",
    labelText: "Draft",
  },
  {
    context: INTERNAL_REVIEW,
    status: ["PENDING_APPROVAL", "REJECTED"],
    heading: "Internal Review",
    subHeading: "Documents pending internal approval",
    labelText: "Pending Approval",
  },
  {
    context: CUSTOMER_REVIEW,
    status: ["APPROVED", "PREPARE_FOR_SIGNATURE"],
    heading: "Customer Review",
    subHeading: "Documents shared with clients",
    labelText: "Approved",
  },
  {
    context: SIGNED,
    status: ["SIGNATURE_PENDING", "DOCUMENT_CLIENT_SIGNED"],
    heading: "Signature",
    subHeading: "Documents signed by clients ",
    labelText: "Signed",
  },
];

const PIPELINE_SWIMLANES = [
  {
    context: OPEN_DOC_LANE,
    status: DRAFT_STATUS,
    heading: "Draft",
    subHeading: "Documents that are editable in draft state",
    labelText: "Draft",
  },
  {
    context: PENDING_APPROVAL_LANE,
    status: "PENDING_APPROVAL",
    heading: "Pending Approval",
    subHeading: "Document pending internal approval",
    labelText: "Pending Approval",
  },
  {
    context: APPROVED_LANE,
    status: "APPROVED",
    heading: "APPROVED",
    subHeading: "Documents that are internally approved",
    labelText: "Approved",
  },
  {
    context: REJECTED_LANE,
    status: "REJECTED",
    heading: "REJECTED",
    subHeading: "Documents that are internally rejected",
    labelText: "Rejected",
  },
  {
    context: SENT_TO_CLIENT_LANE,
    status: "SENT_TO_CLIENT",
    heading: "SENT TO CLIENT",
    subHeading: "Documents shared with client",
    labelText: "Sent to Client",
  },
  {
    context: DOCUMENT_CLIENT_APPROVED_LANE,
    status: "DOCUMENT_CLIENT_APPROVED",
    heading: "Client Approved",
    subHeading: "Documents that are approved by client",
    labelText: "Client Approved",
  },
  {
    context: DOCUMENT_CLIENT_REJECTED_LANE,
    status: "DOCUMENT_CLIENT_REJECTED",
    heading: "Client Rejected",
    subHeading: "Documents that are rejected by client",
    labelText: "Client Rejected",
  },
  {
    context: DOCUMENT_SIGNED_LANE,
    status: "DOCUMENT_CLIENT_SIGNED",
    heading: "Signed",
    subHeading: "Signed and completed Documents",
    labelText: "Signed",
  },
];

const DATE_FILTERS = [
  "None",
  "Past 1 Month",
  "Past 2 Months",
  "Past 6 Months",
  "Custom",
];

const BY_ACCOUNT = "byAccount";
const BY_OWNER = "byOwner";
const BY_DATE = "byDate";
const BY_STAGES = "byStages";
const BY_LAST_UPDATE = "lastUpdate";
const BY_DATE_CREATED = "dateCreated";
const BY_ALPHABETICAL = "A_Z";

const DOCUMENT_STATUS_HASMAP = {
  DRAFT: "DRAFT",
  PENDING_APPROVAL: "PENDING APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  SENT_TO_CLIENT: "SENT TO CLIENT",
  DOCUMENT_CLIENT_APPROVED: "CLIENT APPROVED",
  DOCUMENT_CLIENT_REJECTED: "CLIENT REJECTED",
  PREPARE_FOR_SIGNATURE: "PREPARE FOR SIGNATURE",
  DOCUMENT_CLIENT_SIGNED: "SIGNED",
  SIGNATURE_PENDING: "SIGNATURE PENDING",
};

const ASSET_DOCUMENT_STATUS = [
  "Draft",
  "Internal Approval",
  "Sent",
  "Complete",
  "Declined",
];

const DOCUMENT_STATUS_TOOLTIP_HASMAP = {
  DRAFT: "Draft",
  PENDING_APPROVAL: "Pending Approval",
  APPROVED: "Yet to begin Signature Process",
  REJECTED: "Rejected",
  PREPARE_FOR_SIGNATURE: "Signature Process Incomplete",
  DOCUMENT_CLIENT_SIGNED: "Signed",
  SIGNATURE_PENDING: "Signature Pending",
};

const DOCUMENT_STATUS_LABEL = {
  PENDING_APPROVAL: "PENDING APPROVAL",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED",
  SIGNATURE_PENDING: "SIGNATURE PENDING",
  PREPARE_FOR_SIGNATURE: "PREPARE FOR SIGNATURE",
  DOCUMENT_CLIENT_SIGNED: "SIGNED",
};

const STATIC_STATUS = ["DRAFT", "PENDING_APPROVAL", "REJECTED"];

const DOCUMENT_TYPE_ICONS = {
  Q: QUO,
  MSA,
  SOW,
  SLA,
  NDA,
  CSA,
  SAQ,
  DPA,
};
const DOCUMENT_TYPES = {
  "Quote/Order Form": QUO,
  "Master Service Agreement": MSA,
  "Statement of Work": SOW,
  "Service Contract/SLA": SLA,
  "Non Disclosure Agreement": NDA,
  "Cloud Service Agreement": CSA,
  "Security Assessment Questionnaire": SAQ,
  "Data Processing Agreement": DPA,
};
const ADD_OPPO_FORM = [
  {
    label: "Choose Account",
    name: "account",
    type: "select",
    required: true,
    defaultVal: "",
    span: "full",
    visibility: true,
    selectOptionsKey: "accounts",
    containsSwitchLink: true,
  },
  {
    label: "Opportunity Name",
    name: "opportunity",
    type: "text",
    required: true,
    defaultVal: "",
    span: "full",
    visibility: true,
  },
  {
    label: "Expected Revenue",
    name: "expectedRevenue",
    type: "currency",
    required: true,
    defaultVal: "",
    span: "half",
    visibility: true,
  },
  {
    label: "Close Date",
    name: "closeDate",
    type: "date",
    required: true,
    defaultVal: "",
    span: "half",
    visibility: true,
  },
  {
    label: "Owner",
    name: "owner",
    type: "select",
    required: true,
    defaultVal: "",
    span: "half",
    visibility: true,
    selectOptionsKey: "mentionUsers",
  },
  {
    label: "Opportunity Stages",
    name: "opportunityStage",
    type: "select",
    required: true,
    defaultVal: "",
    span: "half",
    visibility: true,
  },
];

const ADD_ACCOUNT_FORM = [
  {
    label: "Account Name",
    name: "accountName",
    type: "text",
    required: true,
    defaultVal: "",
    span: "full",
    visibility: true,
    containsSwitchLink: true,
  },
  {
    label: "Street",
    name: "accountAddressStreet",
    type: "text",
    required: false,
    defaultVal: "",
    span: "full",
    visibility: true,
  },
  {
    label: "City",
    name: "accountAddressCity",
    type: "text",
    required: false,
    defaultVal: "",
    span: "half",
    visibility: true,
  },
  {
    label: "State",
    name: "accountAddressState",
    type: "text",
    required: false,
    defaultVal: "",
    span: "half",
    visibility: true,
  },
  {
    label: "ZIP Code",
    name: "accountAddressZip",
    type: "text",
    required: false,
    defaultVal: "",
    span: "half",
    visibility: true,
  },
  {
    label: "Country",
    name: "accountAddressCountry",
    type: "text",
    required: false,
    defaultVal: "",
    span: "half",
    visibility: true,
  },
];

const OPPO_STAGES = [
  "Prospecting",
  "Qualification",
  "Needs Analysis",
  "Value Proposition",
  "Id. Decision Makers",
  "Perception Analysis",
  "Proposal/Price Quote",
  "Negotiation/Review",
  "Closed Won",
  "Closed Lost",
];

const DOC_TYPES = {
  "Statement of Work": "SOW",
  "Service Contract / SLA": "SLA",
  "Quote/Order Form": "QUO",
  "Master Service Agreement": "MSA",
  "Data Processing Agreement": "DPA",
  "Cloud Services Agreement": "CSA",
  "Non Disclosure Agreement": "NDA",
  "Security Assessment Questionnaire": "SAQ",
};

const ASSET_DOC_TYPES = ["SLA", "SOW", "Quote", "MSA"];

export {
  ADD_ACCOUNT_FORM,
  ADD_OPPO_FORM,
  ASSET_DOCUMENT_STATUS,
  ASSET_DOC_TYPES,
  APPROVED_LANE,
  BY_ALPHABETICAL,
  BY_DATE_CREATED,
  BY_DATE,
  BY_LAST_UPDATE,
  BY_OWNER,
  BY_ACCOUNT,
  BY_STAGES,
  DATE_FILTERS,
  DEFAULT_SELECTED_LUKE_ANALYTICS,
  DEFAULT_SELECTED_SAMPLE_OPPORTUNITY,
  DOC_TYPES,
  DOCUMENT_CLIENT_APPROVED_LANE,
  DOCUMENT_CLIENT_REJECTED_LANE,
  DOCUMENT_SIGNED_LANE,
  DOCUMENT_STATUS_HASMAP,
  DOCUMENT_STATUS_TOOLTIP_HASMAP,
  DOCUMENT_TYPE_ICONS,
  DRAFT_STATUS,
  OPEN_DOC_LANE,
  OPEN_OPPORTUNITIES_LANE,
  OPPO_STAGES,
  PENDING_APPROVAL_LANE,
  PIPELINE_SWIMLANES,
  NEW_PIPELINE_SWIMLANES,
  REJECTED_LANE,
  SENT_TO_CLIENT_LANE,
  STATIC_STATUS,
  DOCUMENT_STATUS_LABEL,
  // new swimlanes
  DRAFT,
  INTERNAL_REVIEW,
  CUSTOMER_REVIEW,
  SIGNED,
  DOCUMENT_TYPES,
};



// WEBPACK FOOTER //
// ./src/constants/pipeline.js